import { HttpClient } from "./HttpClient"

export const ManagementsService = {
    searchClientByOpc: async function (opc, value) {
        return await HttpClient.get(`/management/get-search-client/${opc}/${value}`).then(response => response)
    },
    getLastManagement: async function (id) {
        return await HttpClient.get(`/management/get-last-management/${id}`).then(response => response)
    },
    getClientInformation: async function (id_client) {
        return await HttpClient.get(`/management/get-client-information/${id_client}`).then(response => response)
    },
    getManagementInformation: async function (id_client) {
        return await HttpClient.get(`/management/get-management-information/${id_client}`).then(response => response)
    },
    getAllManagementInformation: async function (id_client) {
        return await HttpClient.get(`/management/get-all-management-information/${id_client}`).then(response => response)
    },
    getSCLManagementType: async function () {
        return await HttpClient.get(`/management/get-scl-management-type`).then(response => response)
    },
    getActionCodes: async function () {
        return await HttpClient.get(`/management/get-action-code`).then(response => response)
    },
    getResultsCodes: async function (id) {
        return await HttpClient.get(`/management/get-result-code/${id}`).then(response => response)
    },
    getManagementList: async function (id_client) {
        return await HttpClient.get(`/management/get-management-list/${id_client}`).then(response => response)
    },
    getAgreementList: async function (id_client) {
        return await HttpClient.get(`/management/get-agreement-list/${id_client}`).then(response => response)
    },
    saveManagement: async function (form) {
        return await HttpClient.postJSON(`/management/save-management`, form).then(response => response)
    },
    saveIntentionPayment: async function (form) {
        return await HttpClient.postJSON(`/management/save-intention-payment`, form).then(response => response)
    },
    getColaborators: async function () {
        return await HttpClient.get(`/management/get-colaborators`).then(response => response)
    },
    getTelephonesByClient: async function (id_client) {
        return await HttpClient.get(`/telephone/get-telephones-by-client/${id_client}`).then(response => response)
    },
    createTelephoneByClient: async function (form) {
        return await HttpClient.post(`/telephone/create-telephone`, form).then(response => response)
    },
    getManagementType: async function () {
        return await HttpClient.get(`/management/get-management-type`).then(response => response)
    },
    processLikesandDislikes: async function (form) {
        return await HttpClient.postJSON(`/telephone/put-likes-and-dislikes`, form).then(response => response)
    },
    modifyTelephone: async function (id, form) {
        return await HttpClient.postJSON(`/telephone/put-telephone/${id}`, form).then(response => response)
    },
    deleteTelephone: async function (id) {
        return await HttpClient.delete(`/telephone/delete-telephone/${id}`).then(response => response)
    },
    getPDFByUser: async function(id_client) {
        return await HttpClient.get(`/pdf/get-pdf-by-client/${id_client}`).then(response => response)
    },
    getPathPDF: async function(id) {
        return await HttpClient.get(`/pdf/get-file-by-id/${id}`).then(response => response)
    },
    uploadPDF: async function(form) {
        return await HttpClient.post(`/pdf/upload`, form).then(response => response)
    },
    deletePDF: async function(id) {
        return await HttpClient.delete(`/pdf/delete/${id}`).then(response => response)
    },
    paymentHistoric: async function(id_cliente) {
        return await HttpClient.get(`/management/get-payment-historic/${id_cliente}`).then(response => response)
    },
    
    
    getDirectionsHomeAndWorkByClient: async function (id) {
        return await HttpClient.get(`/direction/get-directions-home-and-work-by-client/${id}`).then(response => response)
    },
    createDirectionClient: async function (form) {
        return await HttpClient.postJSON(`/direction/create-direction-client`, form).then(response => response)
    },
    updateDirectionClient: async function (form, id) {
        return await HttpClient.postJSON(`/direction/put-direction-client/${id}`, form).then(response => response)
    },
    deleteDirectionClient: async function (id) {
        return await HttpClient.delete(`/direction/delete-direction/${id}`).then(response => response)
    },
    
    

    getDirectionsAvalByClient: async function (id) {
        return await HttpClient.get(`/direction/get-directions-aval-by-client/${id}`).then(response => response)
    },
    createDirectionClientAval: async function (form) {
        return await HttpClient.postJSON(`/direction/create-direction-client-aval`, form).then(response => response)
    },
    deleteDirectionClientAval: async function (id) {
        return await HttpClient.delete(`/direction/delete-aval-direction/${id}`).then(response => response)
    },
    
    cancelAgreement: async function (id, type_agreement) {
        return await HttpClient.delete(`/management/delete-agreements-intention/${id}/${type_agreement}`).then(response => response)
    },

    async getUsersManagers () {
        return await HttpClient.get(`/user/get-manager-type`).then(response => response)
    },

    async changeAccount(form){
        return await HttpClient.postJSON(`/management/change-account-salesman`, form).then(response => response);
    }
}